export default __webpack_public_path__ + "static/media/result-bg.ac869927.png";